import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create();

function handleSessionExpired() {
  if (typeof window !== 'undefined') {
    window.location.replace('/');
  }
}

api.interceptors.response.use(
  (res) => {
    if (res?.data?.error === 'session expired') {
      handleSessionExpired();
      return Promise.reject(new Error('session expired'));
    }
    return res;
  },
  (err) => {
    const apiError = err?.response?.data?.error;
    if (apiError === 'session expired') {
      handleSessionExpired();
      return Promise.reject(err);
    }

    const msg = apiError || err?.response?.data?.message || err?.message || 'Something went wrong';
    toast.error(msg);
    return Promise.reject(err);
  }
);

export default api;
